// Module
var code = "<dl> <dd> <span class=\"FractionAccumulator__amount\"> {{::accumulator.currentAmount | chCurrency }} </span> <span>/</span> <span class=\"FractionAccumulator__maximum\"> {{::accumulator.maxAmount | chCurrency }} </span> </dd> </dl> ";
// Exports
var _module_exports = code;;
var path = '@collectivehealth/frontend-member-v2/components/fractionAccumulator/fractionAccumulator.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;